import type { TextareaHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

interface ITextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  mono?: boolean;
}

export const Textarea = ({ invalid, mono, className, rows = 6, ...rest }: ITextareaProps) => (
  <textarea
    rows={rows}
    aria-invalid={invalid || undefined}
    className={cn(
      'w-full rounded-control border bg-field px-input py-inset text-body text-primary',
      'focus:border-border-focus focus:ring-3 focus:ring-focus focus:outline-none',
      invalid ? 'border-danger' : 'border-border-raised',
      'disabled:border-border-muted disabled:bg-field-muted disabled:text-muted',
      mono && 'font-mono text-data',
      className,
    )}
    {...rest}
  />
);
